import React from 'react';

type Props = {
  onOpenAddModal: (date: string) => void,
  id?: string,
  small?: boolean,
}

const AddLogButton = (props: Props) => {
  const { id, small } = props;
  let classes = 'btn add-log';
  if (small) {
    classes += ' btn-circle btn-lg';
  }

  return (
    <button
      type="button"
      className={classes}
      id={id}
      onClick={() => props.onOpenAddModal(id)}
    >
      <i className="fa fa-plus" aria-hidden="true" />
    </button>
  );
};

export default AddLogButton;
